import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

type ContainerProps = {
  size?: 'small' | 'large' | 'default';
};

const Container = styled.div<ContainerProps>`
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;

  @media ${device.isDesktop} {
    max-width: ${({ size }) =>
      size === 'small' ? '768px' : size === 'large' ? '1234px' : '960px'};
  }
`;

export default Container;
